__turbopack_context__.v({
  "authorLabel": "repository-card-module__HtueWG__authorLabel",
  "authorName": "repository-card-module__HtueWG__authorName",
  "button": "repository-card-module__HtueWG__button",
  "buttons": "repository-card-module__HtueWG__buttons",
  "image": "repository-card-module__HtueWG__image",
  "readMore": "repository-card-module__HtueWG__readMore",
  "repositoryCard": "repository-card-module__HtueWG__repositoryCard",
});
